<template>
    <div class="bg-gray relative z-0" v-if="equipment" >
        <div class="page-container ">
            <div class="p-0 lg:p-5">
                <h1 class="mb-10 px-5 lg:px-0">
                    Quick Access
                </h1>

                <div class="px-5 lg:px-0">
                    <div class="mb-8 ">
                        <div class="style-emph ">
                            Machine Details
                        </div>
                        <div class="md:w-96">
                            <equipment-card :equipment="equipment"></equipment-card>
                        </div>
                    </div>

                    <div class="mb-8">
                        <div class="style-emph ">
                            Choose an Action
                        </div>
                        <div class="mt-4 md:w-96">
                            <div class="mb-3">
                                <router-link :to="{ name: 'bookServiceCall', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }" class="btn btn--white w-full text-left mb-1 justify-start">
                                    <i class="fas fa-wrench mr-3 text-xl"></i> Request Service Call</router-link>
                            </div>

                            <div class="mb-3">
                                <router-link :to="{ name: 'orderConsumables', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }" class="btn btn--white w-full text-left mb-1 justify-start">
                                    <i class="fas fa-tint mr-3 text-xl"></i> Order Product Consumables</router-link>
                            </div>

                            <div class="mb-3">
                                <router-link :to="{ name: 'meterReadings', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }" class="btn btn--white w-full text-left mb-1 justify-start">
                                    <i class="fas fa-print mr-3 text-xl"></i> Update Meter Readings</router-link>
                            </div>

                            <div class="mb-3">
                                <router-link :to="{ name: 'contact', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }" class="btn btn--white w-full text-left mb-1 justify-start">
                                    <i class="fas fa-phone mr-3 text-xl"></i> Contact</router-link>
                            </div>

                            <div class="mb-3 md:hidden">
                                <router-link :to="{ name: 'signIn' }" class="btn btn--white w-full text-left mb-1 justify-start">
                                    <i class="fas fa-sign-in mr-3 text-xl"></i> Sign In</router-link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">

import EquipmentCard from './includes/EquipmentCard.vue';
import Vuex from 'vuex';

export default {
    name: 'MachineDetail',
    props: ['equipment'],

    data() {
        return {
            submitted: false,
            success: false,
            jobNumber: ''
        }
    },

    components: {
        EquipmentCard
    },

    computed: {
        ...Vuex.mapGetters('equipments', {
            currentItem: 'currentItem'
        }),
    },
    methods: {
        onSuccess(){
            this.success = true;
        }
    },
}
</script>
